import dayjs from "dayjs";
import React from "react";

const OrderSummary = ({ data = {} }) => {
  return (
    <div className="border rounded-lg p-4">
      <div className="text-sm text-gray-600 space-y-1">
        <p>
          Price: ({data?.eventData?.currency?.symbol}){" "}{data?.price}{" "}
          <span className="float-right">
            Quantity: {data?.quantity}
          </span>
        </p>
        <p>
          Sale Start: {dayjs(data?.salesStartDate).format("MMMM DD, YYYY")}
          <span className="float-right">
            Sale End: {dayjs(data?.salesEndDate).format("MMMM DD, YYYY")}
          </span>
        </p>
      </div>
    </div>
  );
};

export default OrderSummary;
